
define('text!templates/modules/calendar/personal-data/item/personal-data-content.html',[],function () { return '<div class="personal-data-details-panel">\n    <div class="personal-data-alert"></div>\n    <div class="personal-data-details-form"></div>\n</div>\n';});

